<template>
  <blockquote
    :key="message.id"
    :class="['blockquote-cite',!(message.isSeen || message.MessageReads?.length) ? 'blockquote-unread' : '' ]"
    style="font-size:14px">
    <p class="display-flex justify-content-between notificaiton-panel-heading">
      <span>
        <v-icon
          small>
          mdi-bell-ring
        </v-icon>
        <strong>{{ ` ${message.subject} ` }}</strong> 
        <small class="no-before-content">{{ getScope(message) }}</small>
      </span>
      <span class="notificaiton-panel-ago">{{ getTime(message.createdAt) }}</span>
    </p>
    <p />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="message.body" /> 
    <footer>
      <cite :title="`SYSTEM`">{{ `SYSTEM` }}</cite>
    </footer>
  </blockquote>
</template>

<script>
const TYPE_NOTIFICATION = 'NOTIFICATION'

import { mapActions,mapState } from 'vuex'
import { API_STATES } from '@/helpers'
import moment from 'moment'

export default {
  name  : "MessageBlockQuote",
  props : {
    message : {
      type     : [Object],
      required : true,
      default  : () => {}
    }
  },
  data(){
    return {
      TYPE_NOTIFICATION,
      isPending : false
    }
  },
  computed : {
    ...mapState({
      messageUpdateState : state => state.dashboard.messageUpdateState,
      messageUpdateError : state => state.dashboard.messageUpdateError,
    })
  },
  watch : {
    messageUpdateState(state){
      if(state !== API_STATES.REQUEST_PENDING){
        this.isPending = false
      }
    }
  },
  methods : {  
    ...mapActions('dashboard',['updateMessage']),

    getScope(message){
      return  [message.recipients || message.MessageRecipients].reduce((type,r)=>{
        if(['company','store'].includes(r.type)){
          type = `(${r.type} wide)`
        }
        return type
      },null)
    },

    getTime (time) {
      return (moment(time, true).isValid() ? moment.utc(time): moment(new Date(time))).fromNow()
    },

    updateMessageState(m,checked){
      const messageId = m.id
      const message =  {
        subject       : m.subject,
        type          : m.type,
        sendEmail     : m.sendEmail,
        sendSms       : m.sendSms,
        sendDashboard : m.sendDashboard,
        companyId     : m.companyId
      } 
      message.isActive = checked ? 1 : 0

      this.isPending = true
      return this.updateMessage({ messageId,message })
    }
  }
}




</script>

<style scoped>
.blockquote-unread {
  border-left-color:  var(--v-secondary-base);;
}

.margin-less-input{
  margin: 0px !important;
}

a.disabled:hover {
  cursor: not-allowed;
}
</style>
